export default __webpack_public_path__ + "static/media/Post-Dispatch-Newspaper-publication-for-AGM.4a30c207.pdf";